import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ProfessionalSkill = () => {
  const percentage = 66;

  return (
    <div className="container mx-auto px-5 mt-20">
      <div className="grid lg:grid-cols-2 grid-cols-1 pt-24">
        <div className="px-3 text-left flex flex-col justify-center items-center">
          <h2 className="text-2xl mb-4 font-bold">Expertise</h2>
          <div className="flex flex-col">
            <label className="font-bold mb-1">React</label>
            <progress
              class="progress  mb-5 progress-warning w-96"
              value="90"
              max="100"
            ></progress>
            <label className="font-bold mb-1">JavaScript</label>
            <progress
              class="progress  mb-5 progress-warning w-96"
              value="80"
              max="100"
            ></progress>
            <label className="font-bold mb-1">Tailwind css</label>
            <progress
              class="progress mb-5  progress-warning w-96"
              value="80"
              max="100"
            ></progress>
            <label className="font-bold mb-1">Html</label>
            <progress
              class="progress  mb-5  progress-warning w-96"
              value="95"
              max="100"
            ></progress>
            <label className="font-bold mb-1">CSS</label>
            <progress
              class="progress  mb-5   progress-warning w-96"
              value="97"
              max="100"
            ></progress>
          </div>
        </div>
        <div className="px-3 text-left flex flex-col justify-center items-center">
          <h2 className="text-2xl mb-4 font-bold">Comfortable</h2>
          <div className="flex flex-col">
            <label className="font-bold mb-1">Node.js</label>
            <progress
              class="progress  mb-5 progress-warning w-96"
              value="90"
              max="100"
            ></progress>
            <label className="font-bold mb-1">Express.js</label>
            <progress
              class="progress  mb-5 progress-warning w-96"
              value="80"
              max="100"
            ></progress>
            <label className="font-bold mb-1">MongoDB</label>
            <progress
              class="progress mb-5  progress-warning w-96"
              value="80"
              max="100"
            ></progress>
            <label className="font-bold mb-1">Styled components</label>
            <progress
              class="progress  mb-5  progress-warning w-96"
              value="95"
              max="100"
            ></progress>
            <label className="font-bold mb-1">Redux</label>
            <progress
              class="progress  mb-5   progress-warning w-96"
              value="97"
              max="100"
            ></progress>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalSkill;
